import React from "react";
import styled from "@emotion/styled";

import UIcon, { IconKey } from "../../../lib/icons/untitled_ui/UIcon";
import { sysPrimaryPressed } from "../../../lib/themes/colors";
import { Flex } from "../../../styles/utility-components";

type TagProps = {
  title?: React.ReactNode;
  icon?: IconKey;
  iconProps?: { color?: string; fill?: boolean };
  backgroundColor?: string;
  borderColor?: string;
  fontColor?: string;
  noShrink?: boolean;
};

export default function Tag({
  title,
  icon,
  iconProps,
  backgroundColor,
  borderColor,
  fontColor,
  noShrink,
}: TagProps) {
  return (
    <Container backgroundColor={backgroundColor} borderColor={borderColor} noShrink={noShrink}>
      {icon && (
        <UIcon
          icon={icon}
          color={iconProps?.color ?? sysPrimaryPressed}
          fill={iconProps?.fill ? "currentColor" : "none"}
          size={12}
        />
      )}
      <TextContainer fontColor={fontColor}>
        <EllipsisText>{title}</EllipsisText>
      </TextContainer>
    </Container>
  );
}

const Container = styled(Flex)<{
  backgroundColor?: string;
  borderColor?: string;
  noShrink?: boolean;
}>(({ theme, backgroundColor, borderColor, noShrink }) => ({
  display: "flex",
  backgroundColor: backgroundColor ?? theme.colors.sysPrimarySubtle,
  height: "24px",
  padding: "0px 10px 0px 8px",
  justifyContent: "center",
  alignItems: "center",
  gap: "6px",
  border: `1px solid ${borderColor}`,
  borderRadius: "3px",
  width: "fit-content",
  minWidth: 0,
  ...(noShrink && {
    flexShrink: 0,
  }),
}));

const TextContainer = styled(Flex)<{ fontColor?: string }>(({ theme, fontColor }) => ({
  color: fontColor ?? theme.colors.sysPrimaryPressed,
  fontWeight: "500",
  fontSize: "12px",
  overflow: "hidden",
}));

const EllipsisText = styled.span({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});
